class state {
	constructor({ current = this.constructor.states.ADD_EDIT }) {
		this.current = current;
	}

	static states = {
		ADD_EDIT: "add-edit",
		BACKGROUND_EDIT: "background-edit",
		LAYER_EDIT: "layer-edit",
		SOUND_EDIT: "sound-edit",
		TEMPLATE_SELECT: "template-select",
		IMAGE_SELECT: "image-select"
	};
}

export default state;
